import i from"./function-uncurry-this.js";var r=i,n=r({}.toString),a=r("".slice),o=function(t){return a(n(t),8,-1)};export{o as default};
